import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as TrendingCategoriesActions from './trending-categories.actions';
import * as TrendingCategoriesSelectors from './trending-categories.selectors';
import { ManagedUser, User } from '@/model/user';

@Injectable({
  providedIn: 'root',
})
export class TrendingCategoriesFacade {
  // Selectors
  readonly parentCategories$ = this.store.select(
    TrendingCategoriesSelectors.selectParentCategories,
  );
  readonly allOffers$ = this.store.select(
    TrendingCategoriesSelectors.selectAllOffers,
  );
  readonly filteredOffers$ = this.store.select(
    TrendingCategoriesSelectors.selectFilteredOffers,
  );
  readonly selectedCategoryId$ = this.store.select(
    TrendingCategoriesSelectors.selectSelectedCategoryId,
  );
  readonly loading$ = this.store.select(
    TrendingCategoriesSelectors.selectTrendingCategoriesLoading,
  );
  readonly error$ = this.store.select(
    TrendingCategoriesSelectors.selectTrendingCategoriesError,
  );
  readonly hasTrendingData$ = this.store.select(
    TrendingCategoriesSelectors.selectHasTrendingData,
  );

  constructor(private readonly store: Store) {}

  // Actions
  loadTrendingData(): void {
    this.store.dispatch(TrendingCategoriesActions.loadTrendingData());
  }

  selectCategory(categoryId: string): void {
    this.store.dispatch(
      TrendingCategoriesActions.selectCategory({ categoryId }),
    );
  }

  applyInitialCategoryFilter(): void {
    this.store.dispatch(TrendingCategoriesActions.applyInitialCategoryFilter());
  }

  reset(): void {
    this.store.dispatch(TrendingCategoriesActions.resetTrendingCategories());
  }

  // Helper method to determine if trending should be shown
  shouldShowTrending(
    isLoggedIn: boolean,
    managedUsers: ManagedUser[] | null | undefined,
    user: User | null | undefined,
  ): boolean {
    return (
      !isLoggedIn ||
      ((!managedUsers || managedUsers.length === 0) &&
        (!user?.categories || user.categories.length === 0))
    );
  }
}
